import { render, staticRenderFns } from "./comentarios-skeleton.vue?vue&type=template&id=2608e3d7&scoped=true&"
import script from "./comentarios-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./comentarios-skeleton.component.ts?vue&type=script&lang=ts&"
import style0 from "./comentarios-skeleton.vue?vue&type=style&index=0&id=2608e3d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608e3d7",
  null
  
)

export default component.exports